import { DeprecatedBreakpoint } from 'js/design_system/DeprecatedBreakpoint';
import useScreenSize from './useScreenSize';

/**
 * @deprecated Use `useBreakpoint` from `js/design_system/hooks/useBreakpoint` instead.
 *
 * Returns the largest breakpoint that isn't wider than the current screensize, or returns
 * the smallest breakpoint if the screen size is too small.
 */
const useDeprecatedBreakpoint = (): DeprecatedBreakpoint => {
  const { screenWidth } = useScreenSize();
  // This looks bizarre, but enums transpile to an object containing not just key: value
  // pairs but also value: key pairs, so we have to filter out the value: key pairs
  const breakpoints = Object.values(DeprecatedBreakpoint)
    .filter((v): v is DeprecatedBreakpoint => typeof v === 'number')
    .sort((a, b) => a - b);
  if (screenWidth < breakpoints[0]) {
    return breakpoints[0];
  } else {
    const idx = breakpoints.findIndex((bp) => bp > screenWidth);
    return idx === -1
      ? breakpoints[breakpoints.length - 1]
      : breakpoints[idx - 1];
  }
};

export default useDeprecatedBreakpoint;
